import React from "react";

export type BirthdayIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 24,
    height: 24,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 24,
    height: 24,
  },
};

export const BirthdayIcon = React.forwardRef<SVGSVGElement, BirthdayIconProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "#E01B3F" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];
    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.1125 22.5638H4.91218C4.3075 22.5638 3.81344 22.0716 3.81344 21.4651L3.8125 14.8332L4.96095 15.7772C5.26844 16.0304 5.66595 16.1691 6.08408 16.1691C6.63908 16.1691 7.16033 15.9178 7.5072 15.48L8.05846 14.7844L8.60971 15.4782C8.95659 15.9169 9.4741 16.1672 10.0328 16.1672C10.5907 16.1672 11.1091 15.916 11.456 15.4782L12.0072 14.7844L12.5585 15.4782C12.9054 15.9169 13.4257 16.1672 13.9816 16.1672C14.5394 16.1672 15.0579 15.916 15.4047 15.4782L15.956 14.7844L16.5072 15.4782C16.8541 15.9169 17.3744 16.1672 17.9341 16.1672C18.3466 16.1672 18.7404 16.0285 19.0779 15.766L20.2141 14.88V21.4613C20.2122 22.0707 19.7182 22.5638 19.1126 22.5638H19.1125ZM5.21866 21.1576H18.8031V17.4582C18.5219 17.5379 18.2294 17.5773 17.9313 17.5773C17.2019 17.5773 16.5109 17.3354 15.9531 16.9023C15.3953 17.3354 14.7063 17.5773 13.9797 17.5773C13.2531 17.5773 12.5641 17.3382 12.0062 16.9023C11.4484 17.3354 10.7594 17.5773 10.0328 17.5773C9.30622 17.5773 8.61718 17.3382 8.05935 16.9023C7.50154 17.3354 6.81248 17.5773 6.0859 17.5773C5.79058 17.5773 5.49996 17.5379 5.22152 17.4601V21.1575L5.21866 21.1576Z"
          fill={color}
        />
        <path
          d="M17.9307 17.5781C17.2041 17.5781 16.5151 17.3363 15.9544 16.9031C15.3966 17.3363 14.7076 17.5781 13.981 17.5781C13.2544 17.5781 12.5654 17.3391 12.0047 16.9031C11.4469 17.3363 10.7578 17.5781 10.0313 17.5781C9.30472 17.5781 8.61566 17.3391 8.05782 16.9031C7.50002 17.3363 6.81095 17.5781 6.08157 17.5781C5.35218 17.5781 4.63782 17.3269 4.07063 16.8731C3.30189 16.2591 2.85938 15.3403 2.85938 14.356C2.85938 12.5795 4.30499 11.1328 6.08258 11.1328C6.2982 11.1328 7.2057 11.1328 8.42819 11.1347L10.6201 11.1366C11.5294 11.1366 12.4838 11.1384 13.3933 11.1384H13.4983C15.7014 11.1403 17.6044 11.1403 17.9308 11.1403C19.7074 11.1403 21.154 12.5841 21.154 14.3587C21.154 15.3431 20.7134 16.259 19.9428 16.8758C19.3728 17.3268 18.6603 17.578 17.9309 17.578L17.9307 17.5781ZM15.9544 14.7862L16.5057 15.48C16.8526 15.9187 17.3729 16.169 17.9288 16.169C18.346 16.169 18.7369 16.0331 19.0613 15.7734C19.4944 15.4265 19.7438 14.9109 19.7438 14.3559C19.7438 13.3575 18.9282 12.5447 17.927 12.5447C17.5988 12.5447 15.6957 12.5428 13.4925 12.5428H13.3875C12.4781 12.5428 11.5237 12.5409 10.6143 12.5409L8.42241 12.539C7.19896 12.539 6.29428 12.5372 6.07679 12.5372C5.07554 12.5372 4.25992 13.3528 4.25992 14.354C4.25992 14.909 4.50837 15.4246 4.94243 15.7715C5.26869 16.0321 5.65962 16.1671 6.07494 16.1671C6.63275 16.1671 7.1512 15.9159 7.49807 15.4781L8.04933 14.7843L8.60058 15.4781C8.94746 15.9168 9.46497 16.1671 10.0237 16.1671C10.5815 16.1671 11.1 15.9159 11.4468 15.4781L11.9981 14.7843L12.5494 15.4781C12.8962 15.9168 13.4165 16.1671 13.9744 16.1671C14.5322 16.1671 15.0506 15.9159 15.3994 15.4781L15.9544 14.7862Z"
          fill={color}
        />
        <path
          d="M14.1013 12.5439H13.3982C12.4748 12.5439 11.5307 12.542 10.625 12.542H9.92188V8.57364C9.92188 8.05989 10.3391 7.6427 10.8528 7.6427H13.1684C13.6822 7.6427 14.0994 8.05989 14.0994 8.57364L14.0984 12.544L14.1013 12.5439ZM11.3281 11.1358H12.695V9.04704H11.3281V11.1358Z"
          fill={color}
        />
        <path
          d="M12.0078 7.03421C10.7281 7.03421 9.6875 5.99359 9.6875 4.71389V4.70639C9.695 3.96764 10.0419 3.20826 10.6859 2.50794C11.1406 2.01294 11.5972 1.70919 11.6188 1.697L12.0219 1.42981L12.4156 1.71107C12.4363 1.72513 12.9144 2.06919 13.3794 2.57826C14.0638 3.32826 14.3825 4.05951 14.3262 4.75139C14.3094 6.00951 13.2753 7.03419 12.0078 7.03419L12.0078 7.03421ZM11.0938 4.71576C11.0956 5.21731 11.5044 5.62514 12.0078 5.62514C12.5122 5.62514 12.9219 5.21453 12.9219 4.71108V4.67545L12.9238 4.63983C12.9519 4.36327 12.7381 3.95544 12.3406 3.51951C12.2234 3.39294 12.1044 3.27576 11.9984 3.18012C11.5934 3.55138 11.1003 4.13263 11.0938 4.71574L11.0938 4.71576Z"
          fill={color}
        />
      </svg>
    );
  }
);

BirthdayIcon.displayName = "BirthdayIcon";
